export const FLAT_DESCRIPTION_INIT = 'FLAT_DESCRIPTION_INIT'
export const FLAT_DESCRIPTION_EDIT_ON = 'FLAT_DESCRIPTION_EDIT_ON'
export const FLAT_DESCRIPTION_EDIT_OFF = 'FLAT_DESCRIPTION_EDIT_OFF'
export const FLAT_DESCRIPTION_SAVE = 'FLAT_DESCRIPTION_SAVE'
export const FLAT_DESCRIPTION_SAVED = 'FLAT_DESCRIPTION_SAVED'
export const FLAT_DESCRIPTION_SET_VALUE = 'FLAT_DESCRIPTION_SET_VALUE'
